import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import DashboardSidebar from './DashboardSidebar';
import { SIDEBAR_WIDTH_EXPANDED, SIDEBAR_WIDTH_MINI } from './sidebarConstants';
import useResponsive from '../../hooks/useResponsive';

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: 20,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

export default function DashboardLayout() {
  const isDesktop = useResponsive('up', 'lg');
  const collapsed = !isDesktop;
  const drawerWidth = collapsed ? SIDEBAR_WIDTH_MINI : SIDEBAR_WIDTH_EXPANDED;

  return (
    <RootStyle>
      <DashboardSidebar collapsed={collapsed} drawerWidth={drawerWidth} />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
